// Custom FAQs
document.addEventListener('DOMContentLoaded', function () {
  const items = document.querySelectorAll('.shy-faq-item');

  items.forEach(item => {
    const trigger = item.querySelector('.shy-faq-question');
    const icon = item.querySelector('.shy-icon');
    const answer = item.querySelector('.shy-faq-answer');

    const toggle = () => {
      const isOpen = item.classList.contains('shy-active');

      // Close all
      items.forEach(i => {
        i.classList.remove('shy-active');
        i.querySelector('.shy-icon').textContent = '+';
        const ans = i.querySelector('.shy-faq-answer');
        ans.style.height = '0px';
        ans.style.paddingTop = '0px';
        ans.style.paddingBottom = '0px';
        i.querySelector('.shy-faq-question').setAttribute('aria-expanded', 'false');
      });

      // Open current
      if (!isOpen) {
        item.classList.add('shy-active');
        icon.textContent = '−';
        answer.style.height = answer.scrollHeight + 20 + 'px';
        answer.style.paddingTop = '10px';
        answer.style.paddingBottom = '15px';
        trigger.setAttribute('aria-expanded', 'true');
      }
    };

    trigger.addEventListener('click', toggle);
    trigger.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle();
      }
    });
  });
});
